var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.02637 10.917V13H5.10942L11.253 6.85639L9.16998 4.77334L3.02637 10.917ZM12.8639 5.2455C12.9154 5.19411 12.9563 5.13307 12.9841 5.06587C13.012 4.99867 13.0264 4.92663 13.0264 4.85388C13.0264 4.78113 13.012 4.7091 12.9841 4.6419C12.9563 4.5747 12.9154 4.51366 12.8639 4.46227L11.5641 3.16245C11.5127 3.11095 11.4517 3.0701 11.3845 3.04222C11.3173 3.01435 11.2452 3 11.1725 3C11.0997 3 11.0277 3.01435 10.9605 3.04222C10.8933 3.0701 10.8323 3.11095 10.7809 3.16245L9.76434 4.17898L11.8474 6.26203L12.8639 5.2455Z",
    fill: "#F9FCFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencilIcon.52fea93b58c05002d9640e480d7ff77a.svg";
export { ForwardRef as ReactComponent };